const INVALID_CREDENTIALS = {
    code: 'INVALID_EMAIL_OR_PASSWORD',
    message: 'Invalid email or password',
} as const

const AUTHENTICATION_UNAVAILABLE_MESSAGE = 'Unable to sign in. Please try again.'

function isEmailAuthRequest(request: Request, action: 'sign-in' | 'sign-up') {
    const path = new URL(request.url).pathname.replace(/\/+$/, '')
    return request.method === 'POST' && path.endsWith(`/api/auth/${action}/email`)
}

export function isPublicSignUpRequest(request: Request) {
    return isEmailAuthRequest(request, 'sign-up')
}

export function getPublicAuthenticationError(status = 401) {
    return status === 401 || status === 403
        ? INVALID_CREDENTIALS.message
        : AUTHENTICATION_UNAVAILABLE_MESSAGE
}

export function normalizePublicAuthenticationResponse(request: Request, response: Response) {
    const isAuthenticationFailure = response.status === 401 || response.status === 403

    if (!isEmailAuthRequest(request, 'sign-in') || !isAuthenticationFailure) {
        return response
    }

    return Response.json(INVALID_CREDENTIALS, { status: 401 })
}
